import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "deck" }
const _hoisted_2 = { class: "deck-title" }
const _hoisted_3 = { class: "deck-list" }
const _hoisted_4 = { class: "deck" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "deck-name" }, "- 稳妥起见 -", -1)
const _hoisted_6 = { class: "deck" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "deck-name" }, "- 险中求胜 -", -1)
const _hoisted_8 = { class: "deck" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "deck-name" }, "- 对赌博弈 -", -1)
const _hoisted_10 = { class: "deck" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "deck-name" }, "- 时来运转 -", -1)
const _hoisted_12 = { class: "deck" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "deck-name" }, "- 身心奉献 -", -1)
const _hoisted_14 = { class: "deck-count" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "deck-list-info" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "卡池信息"),
  /*#__PURE__*/_createElementVNode("p", { class: "deck-type-info safe" }, "卡池1 稳妥起见 - safe（7张微弱增益 1张强大增益 4张微弱不适）"),
  /*#__PURE__*/_createElementVNode("p", { class: "deck-type-info danger" }, "卡池2 险中求胜 - danger (5张微弱增益 2张强大增益 1张欧皇增益 1张微弱不适 3张重度不适)"),
  /*#__PURE__*/_createElementVNode("p", { class: "deck-type-info gambit" }, "卡池3 对赌博弈 - gambit（5张强大增益 1张欧皇增益 5张重度不适 1张反人类）"),
  /*#__PURE__*/_createElementVNode("p", { class: "deck-type-info luck" }, "卡池4 时来运转 - luck（1张强大增益 1张欧皇增益 1张重度不适 1张反人类 8张特殊卡牌）"),
  /*#__PURE__*/_createElementVNode("p", { class: "deck-type-info devote" }, "卡池5 身心奉献 - devote（6张辅助卡牌 6张重度不适）"),
  /*#__PURE__*/_createElementVNode("p", { class: "deck-type-info" }, " 如果想玩安逸的则可以抽取 稳妥起见， 如果想体验一点刺激的则可以抽取 险中求胜， 如果想当赌狗玩更刺激的则可以抽取 对赌博弈， 如果想逆转命运的则可以抽取 时来运转， 如果想为团队当工具人的则可以抽取 身心奉献 ")
], -1)
const _hoisted_16 = { class: "deck-confirm-box" }
const _hoisted_17 = { class: "deck-list-info" }
const _hoisted_18 = { class: "deck-list-name" }
const _hoisted_19 = { class: "deck-list-count" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "card card-front" }
const _hoisted_22 = { class: "card-info" }
const _hoisted_23 = { class: "card-id" }
const _hoisted_24 = { class: "card-name" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "card card-back" }, null, -1)
const _hoisted_26 = { class: "deck-confirm-box" }
const _hoisted_27 = {
  key: 0,
  class: "deck-closed"
}

import {drawCardCount} from "@/assets/ts/utils";
import {
  microGainCount,
  strongGainCount,
  opportunityCount,
  microDiscomfortCount,
  strongDiscomfortCount,
  unacceptableCount,
  technologyCount,
  supportCount,
  deckClosed,
  deckListName,
  deckListText,
  flips,
  deckInfoDialogVisible,
  deckDialogVisible,
  decks,
  deck,
  showDeck,
  closeDeck,
  clickCard,
  initDeck
} from "@/assets/ts/deck";


export default /*#__PURE__*/_defineComponent({
  __name: 'DeckView',
  setup(__props) {

initDeck();

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, "您有 " + _toDisplayString(_unref(drawCardCount)) + " 次抽取卡牌的机会", 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "deck-1",
          id: "safe",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(showDeck)('safe')))
        }),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: "deck-2",
          id: "danger",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(showDeck)('danger')))
        }),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: "deck-3",
          id: "gambit",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(showDeck)('gambit')))
        }),
        _hoisted_9
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", {
          class: "deck-4",
          id: "luck",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(showDeck)('luck')))
        }),
        _hoisted_11
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", {
          class: "deck-5",
          id: "devote",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(showDeck)('devote')))
        }),
        _hoisted_13
      ])
    ]),
    _createElementVNode("p", _hoisted_14, "当前卡池数量： 微弱增益：" + _toDisplayString(_unref(microGainCount)) + " 张 | 强大增益：" + _toDisplayString(_unref(strongGainCount)) + " 张 | 欧皇卡牌：" + _toDisplayString(_unref(opportunityCount)) + " 张 | 微弱不适：" + _toDisplayString(_unref(microDiscomfortCount)) + " 张 | 重度不适：" + _toDisplayString(_unref(strongDiscomfortCount)) + " 张 | 反人类：" + _toDisplayString(_unref(unacceptableCount)) + " 张 | 特殊卡牌：" + _toDisplayString(_unref(technologyCount)) + " 张 | 辅助卡牌：" + _toDisplayString(_unref(supportCount)) + " 张 ", 1),
    _createElementVNode("button", {
      class: "button deck-info",
      onClick: _cache[5] || (_cache[5] = ($event: any) => (deckInfoDialogVisible.value = true))
    }, "卡池信息"),
    _createVNode(_component_el_dialog, {
      class: "dialog deck-info-dialog",
      modelValue: _unref(deckInfoDialogVisible),
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(deckInfoDialogVisible) ? (deckInfoDialogVisible).value = $event : null)),
      "close-on-click-modal": false,
      width: "79.25rem",
      "align-center": ""
    }, {
      default: _withCtx(() => [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            type: "button",
            class: "button deck-cancel",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (deckInfoDialogVisible.value = false))
          }, "取消")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "dialog deck-dialog",
      modelValue: _unref(deckDialogVisible),
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(deckDialogVisible) ? (deckDialogVisible).value = $event : null)),
      "close-on-click-modal": false,
      width: "79.25rem",
      "align-center": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(deckListName)), 1),
          _createElementVNode("p", _hoisted_19, " 卡池说明：" + _toDisplayString(_unref(deckListText)), 1)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["deck-list-box", {'deck-1': _unref(decks)[0],
                                        'deck-2': _unref(decks)[1],
                                        'deck-3': _unref(decks)[2],
                                        'deck-4': _unref(decks)[3],
                                        'deck-5': _unref(decks)[4]}])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deck), (card, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["card-item", {flip: _unref(flips)[index]}]),
              key: index,
              onClick: ($event: any) => (_unref(clickCard)(card, index))
            }, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("p", _hoisted_23, _toDisplayString(card.name), 1),
                  _createElementVNode("p", _hoisted_24, _toDisplayString(card.cardName), 1)
                ])
              ]),
              _hoisted_25
            ], 10, _hoisted_20))
          }), 128))
        ], 2),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("button", {
            type: "button",
            class: "button deck-cancel",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_unref(closeDeck) && _unref(closeDeck)(...args)))
          }, "取消")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_unref(deckClosed))
      ? (_openBlock(), _createElementBlock("div", _hoisted_27))
      : _createCommentVNode("", true)
  ]))
}
}

})